/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type VerifyPasswordResetTokenMutationVariables = Exact<{
  token: string;
}>;


export type VerifyPasswordResetTokenMutation = { verifyPasswordResetToken: { verified: boolean } };

export type ChangePasswordWithoutLoggedInMutationVariables = Exact<{
  token: string;
  password: string;
}>;


export type ChangePasswordWithoutLoggedInMutation = { changePasswordWithoutLoggedIn: { success: boolean } };


export const VerifyPasswordResetTokenDocument = gql`
    mutation verifyPasswordResetToken($token: String!) {
  verifyPasswordResetToken(token: $token) {
    verified
  }
}
    `;

/**
 * __useVerifyPasswordResetTokenMutation__
 *
 * To run a mutation, you first call `useVerifyPasswordResetTokenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPasswordResetTokenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useVerifyPasswordResetTokenMutation({
 *   variables: {
 *     token: // value for 'token'
 *   },
 * });
 */
export function useVerifyPasswordResetTokenMutation(options: VueApolloComposable.UseMutationOptions<VerifyPasswordResetTokenMutation, VerifyPasswordResetTokenMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<VerifyPasswordResetTokenMutation, VerifyPasswordResetTokenMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<VerifyPasswordResetTokenMutation, VerifyPasswordResetTokenMutationVariables>(VerifyPasswordResetTokenDocument, options);
}
export type VerifyPasswordResetTokenMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<VerifyPasswordResetTokenMutation, VerifyPasswordResetTokenMutationVariables>;
export const ChangePasswordWithoutLoggedInDocument = gql`
    mutation changePasswordWithoutLoggedIn($token: String!, $password: String!) {
  changePasswordWithoutLoggedIn(token: $token, password: $password) {
    success
  }
}
    `;

/**
 * __useChangePasswordWithoutLoggedInMutation__
 *
 * To run a mutation, you first call `useChangePasswordWithoutLoggedInMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordWithoutLoggedInMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChangePasswordWithoutLoggedInMutation({
 *   variables: {
 *     token: // value for 'token'
 *     password: // value for 'password'
 *   },
 * });
 */
export function useChangePasswordWithoutLoggedInMutation(options: VueApolloComposable.UseMutationOptions<ChangePasswordWithoutLoggedInMutation, ChangePasswordWithoutLoggedInMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ChangePasswordWithoutLoggedInMutation, ChangePasswordWithoutLoggedInMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ChangePasswordWithoutLoggedInMutation, ChangePasswordWithoutLoggedInMutationVariables>(ChangePasswordWithoutLoggedInDocument, options);
}
export type ChangePasswordWithoutLoggedInMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ChangePasswordWithoutLoggedInMutation, ChangePasswordWithoutLoggedInMutationVariables>;